/**
 * Callout box of `.chilldoc` (APM-CD2-a, docs/plan-chilldoc-v2.md §1): a block
 * node `callout` with one attribute `kind`. Shared by the editor (web), the
 * readable markdown head of the file and the `.docx` exporter, so the five
 * kinds live here once.
 */
export const CHILLDOC_CALLOUT_KINDS = ['note', 'tip', 'warning', 'danger', 'success'];
/** Unknown / missing kind (file of a later version, hand-edited HTML) falls back to `note`. */
export function calloutKindOf(value) {
    return CHILLDOC_CALLOUT_KINDS.includes(value)
        ? value
        : 'note';
}
//# sourceMappingURL=chilldoc-callout.js.map